// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';


var x = String.fromCharCode(160);

var carbs = /* array */[
  /* record */[
    /* id */1,
    /* name */"Reis",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Kartoffeln",
    /* quantity : array */[
      "140" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Nudeln",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Süßkartoffeln",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Quinoa",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Quinoaflocken",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Quinoa gepufft",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Amaranth gepufft",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Couscous",
    /* quantity : array */[
      "40" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Haferflocken",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Reiswaffeln",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Vollkornbrot",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Amaranth",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Knäckebrot",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"(Dinkel-) Vollkornmehl",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Dinkelgrieß",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Bulgur",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Buchweizen",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Reispapier",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Haferkleie",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Hirse",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Polenta",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var protein = /* array */[
  /* record */[
    /* id */1,
    /* name */"Hähnchen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Garnelen",
    /* quantity : array */[
      "220" + (String(x) + "") + "g",
      "185" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Rinderfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Magerquark",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"",
    /* quantity : array */[
      "1 Ei + 8 Eiklar",
      "1 Ei + 6 Eiklar",
      "1 Ei + 4 Eiklar"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Wildlachs",
    /* quantity : array */[
      "220" + (String(x) + "") + "g",
      "185" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Fettarmer Aufschnitt",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Soja-Filet-Stücke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Proteinpulver",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Kalbsfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Schweinefilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Lammfilet",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Thunfisch (in eigenem Saft)",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Forelle",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Seelachs",
    /* quantity : array */[
      "270" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "175" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Pangasius",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Dorade",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Harzer Käse",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Tofu",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "80" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Sojajoghurt ungesüßt",
    /* quantity : array */[
      "500" + (String(x) + "") + "g",
      "400" + (String(x) + "") + "g",
      "300" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Valess Geschnetzeltes",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Soja Hack",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g",
      "90" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Linsen",
    /* quantity : array */[
      "65" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Kidney Bohnen",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */25,
    /* name */"Kichererbsen",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */26,
    /* name */"Kräuterquark",
    /* quantity : array */[
      "270" + (String(x) + "") + "g",
      "220" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */27,
    /* name */"Joghurt 1,5%",
    /* quantity : array */[
      "325" + (String(x) + "") + "g",
      "275" + (String(x) + "") + "g",
      "225" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */28,
    /* name */"Hüttenkäse",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */29,
    /* name */"Frischkäse 0,2%",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */30,
    /* name */"Skyrella",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */31,
    /* name */"Tatar",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */32,
    /* name */"Linsennudeln",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */33,
    /* name */"Kichererbsennudeln",
    /* quantity : array */[
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */34,
    /* name */"Skyr",
    /* quantity : array */[
      "300" + (String(x) + "") + "g",
      "250" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */35,
    /* name */"Kichererbsen (getrocknet)",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */36,
    /* name */"Kidneybohnen (getrocknet)",
    /* quantity : array */[
      "70" + (String(x) + "") + "g",
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */37,
    /* name */"Weiße Bohnen (Abtropfgewicht)",
    /* quantity : array */[
      "225" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */38,
    /* name */"Schwarze Bohnen (Abtropfgewicht)",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */41,
    /* name */"Clean Protein Pancakes",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */42,
    /* name */"Clean Protein Muffins",
    /* quantity : array */[
      "60" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */43,
    /* name */"Clean Protein Waffles",
    /* quantity : array */[
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g",
      "35" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */44,
    /* name */"Smacktastic Ice Cream",
    /* quantity : array */[
      "65" + (String(x) + "") + "g",
      "55" + (String(x) + "") + "g",
      "45" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */45,
    /* name */"LikeMeat Filetstücke Hähnchen-Art",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */46,
    /* name */"LikeMeat Filetstücke Döner-Art",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */47,
    /* name */"LikeMeat Gyros Streifen",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */48,
    /* name */"LikeMeat Grilled Chicken Paprika",
    /* quantity : array */[
      "170" + (String(x) + "") + "g",
      "140" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */49,
    /* name */"Alnatura Seitan-Medaillons",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "125" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */50,
    /* name */"Dennree Seitan mariniert",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */51,
    /* name */"Bacon light <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */52,
    /* name */"Speckwürfel light <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */53,
    /* name */"Light Wiener <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */54,
    /* name */"Fettarmer Schinken <5% Fett",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "170" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */39,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */40,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var fat = /* array */[
  /* record */[
    /* id */1,
    /* name */"Öl",
    /* quantity : array */[
      "2TL",
      "2TL",
      "2TL"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Avocado",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Nüsse / Nussmus",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Eier",
    /* quantity : array */[
      "2",
      "2",
      "2"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Chiasamen",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Leinsamen",
    /* quantity : array */[
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g",
      "20" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Oliven",
    /* quantity : array */[
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g",
      "50" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Kokosraspeln",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Sesam / Tahin",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Kerne",
    /* quantity : array */[
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g",
      "15" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var veggies = /* array */[
  /* record */[
    /* id */1,
    /* name */"Blattsalat",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Zucchini",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Blumenkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Gurke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Champignons",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Rucola",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Blattspinat",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Radieschen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Aubergine",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Porree",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Grüne Bohnen",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Tomaten",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Paprika grün",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Brokkoli",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Rosenkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Artischoke",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Grünkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */20,
    /* name */"Fenchel",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Sellerie",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */22,
    /* name */"Spargel",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */23,
    /* name */"Spitzkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */24,
    /* name */"Rot-/Weißkohl",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */25,
    /* name */"Wirsing",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */26,
    /* name */"Lauch / Porree",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var fruits = /* array */[
  /* record */[
    /* id */1,
    /* name */"Apfel",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Birnen",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Beeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Banane",
    /* quantity : array */[
      "75" + (String(x) + "") + "g",
      "75" + (String(x) + "") + "g",
      "75" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Erdbeeren",
    /* quantity : array */[
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g",
      "200" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Himbeeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Heidelbeeren",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"Orange",
    /* quantity : array */[
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g",
      "130" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Mandarine",
    /* quantity : array */[
      "110" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g",
      "110" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"Mango",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Ananas",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Kiwi",
    /* quantity : array */[
      "115" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g",
      "115" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Wassermelone",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Honigmelone",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Pfirsich",
    /* quantity : array */[
      "120" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g",
      "120" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Kirschen",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Grapefruit",
    /* quantity : array */[
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g",
      "150" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */18,
    /* name */"Weintrauben",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */19,
    /* name */"Pflaume",
    /* quantity : array */[
      "135" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g",
      "135" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */21,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var snacks = /* array */[
  /* record */[
    /* id */1,
    /* name */"Proteinpulver",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */2,
    /* name */"Harzer Käse",
    /* quantity : array */[
      "95" + (String(x) + "") + "g",
      "95" + (String(x) + "") + "g",
      "95" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */3,
    /* name */"Hähnchenbrustfilet",
    /* quantity : array */[
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g",
      "100" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */4,
    /* name */"Magerquark",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */5,
    /* name */"Sojajoghurt",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */6,
    /* name */"Sojamilch Light",
    /* quantity : array */[
      "400" + (String(x) + "") + "ml",
      "400" + (String(x) + "") + "ml",
      "400" + (String(x) + "") + "ml"
    ]
  ],
  /* record */[
    /* id */7,
    /* name */"Milch 1,5%",
    /* quantity : array */[
      "200" + (String(x) + "") + "ml",
      "200" + (String(x) + "") + "ml",
      "200" + (String(x) + "") + "ml"
    ]
  ],
  /* record */[
    /* id */8,
    /* name */"",
    /* quantity : array */[
      "6" + (String(x) + "") + "Eiklar",
      "6" + (String(x) + "") + "Eiklar",
      "6" + (String(x) + "") + "Eiklar"
    ]
  ],
  /* record */[
    /* id */9,
    /* name */"Skyr",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */12,
    /* name */"Clean Protein Pancakes",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */13,
    /* name */"Clean Protein Muffins",
    /* quantity : array */[
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g",
      "30" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */14,
    /* name */"Clean Protein Waffles",
    /* quantity : array */[
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g",
      "25" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */15,
    /* name */"Smacktastic Ice Cream",
    /* quantity : array */[
      "40" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g",
      "40" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */16,
    /* name */"Mein Q Protein Quark",
    /* quantity : array */[
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g",
      "180" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */17,
    /* name */"Ehrmann High Protein Pudding",
    /* quantity : array */[
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g",
      "160" + (String(x) + "") + "g"
    ]
  ],
  /* record */[
    /* id */10,
    /* name */"ROCKA-MAHLZEIT",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ],
  /* record */[
    /* id */11,
    /* name */"Rezeptbuch",
    /* quantity : array */[
      "",
      "",
      ""
    ]
  ]
];

var foodPlanSeed = /* array */[
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ],
  /* array */[
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ],
    /* array */[
      "",
      "",
      "",
      ""
    ]
  ]
];

exports.x = x;
exports.carbs = carbs;
exports.protein = protein;
exports.fat = fat;
exports.veggies = veggies;
exports.fruits = fruits;
exports.snacks = snacks;
exports.foodPlanSeed = foodPlanSeed;
/* x Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/foodSeed.re
// module id = 47
// module chunks = 0